import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/recentPurchases';
const FIRST_DELAY = 6000;
const VISIBLE_MS = 5500;
const GAP_MS = 12000;

/**
 * Aviso de compra reciente. Solo aparece si data/recentPurchases.ts tiene
 * compras reales cargadas; con el array vacío no renderiza nada.
 */
export function PurchaseNotifications() {
  if (recentPurchases.length === 0) return null;
  return <PurchaseToast data-id="element-241" data-mp="crnlpativcat" />;
}
function PurchaseToast() {
  const reduceMotion = useReducedMotion();
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      timeout = setTimeout(hide, VISIBLE_MS);
    };
    const hide = () => {
      setVisible(false);
      timeout = setTimeout(() => {
        setIndex(i => (i + 1) % recentPurchases.length);
        show();
      }, GAP_MS);
    };
    timeout = setTimeout(show, FIRST_DELAY);
    return () => clearTimeout(timeout);
  }, [dismissed]);
  if (dismissed) return null;
  const purchase = recentPurchases[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-4 z-40 max-w-[calc(100vw-2rem)] sm:bottom-6 sm:left-6" data-id="element-242" data-mp="ewgmsofagcmb">
      <AnimatePresence data-id="element-243" data-mp="1cgtf18edzl67">
        {visible && <motion.div key={index} initial={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 14,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 10
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-[320px] max-w-full items-start gap-3 rounded-xl border border-paper-dark bg-white p-3.5 shadow-card" data-id="element-244" data-mp="17l4byv35rm55">
            <span className="mt-0.5 flex h-8 w-8 flex-none items-center justify-center rounded-full bg-moss-soft" data-id="element-245" data-mp="3kruc3frci4kt">
              <CheckIcon className="h-4 w-4 text-moss-deep" aria-hidden="true" data-id="element-246" data-mp="3ppdo090km59l" />
            </span>
            <p className="min-w-0 flex-1 text-[13px] leading-snug text-pine" data-id="element-247" data-mp="3as3dp2znz5fg">
              <span className="font-bold" data-id="element-248" data-mp="3fqogna6aw37l">{purchase.name}</span> in{' '}
              {purchase.city}, {purchase.state} just got Troop Night Ready
            </p>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss purchase notifications" className="-mr-1 -mt-1 flex h-7 w-7 flex-none items-center justify-center rounded-full text-pine-muted transition-colors duration-150 hover:bg-paper hover:text-pine focus:outline-none focus-visible:ring-2 focus-visible:ring-ember" data-id="element-249" data-mp="36r1e2l1u4rcy">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-250" data-mp="2n3k5sokj0unw" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}